var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeFolderItem = function SvgTreeFolderItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    x: 3.333,
    y: 5.5,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 1.5,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    stroke: "#222",
    strokeWidth: 1.5,
    d: "M3.333 10.5a1 1 0 0 1 1-1h4v11h-4a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#75AAFF",
    stroke: "#222",
    strokeWidth: 1.5,
    d: "M3.333 6.5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3h-18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.333 12.75h2.5M12.333 15.75h5.5"
  })));
};
export default SvgTreeFolderItem;